import { render, staticRenderFns } from "./ItemListReintegro.vue?vue&type=template&id=4e5e7cea"
import script from "./ItemListReintegro.vue?vue&type=script&lang=ts"
export * from "./ItemListReintegro.vue?vue&type=script&lang=ts"
import style0 from "./ItemListReintegro.vue?vue&type=style&index=0&id=4e5e7cea&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e5e7cea')) {
      api.createRecord('4e5e7cea', component.options)
    } else {
      api.reload('4e5e7cea', component.options)
    }
    module.hot.accept("./ItemListReintegro.vue?vue&type=template&id=4e5e7cea", function () {
      api.rerender('4e5e7cea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemListReintegro.vue"
export default component.exports